<template>
  <div  class="head-page">
    <Header :title="$t('security.title')" />
    <van-cell-group>
      <van-cell
        :title="$t('security.modifypwd')"
        :value="$t('common.modify')"
        is-link
        to="/modifyPwd"
      />
      <van-cell v-if="safeWapConfig.traders_password_switch == 1"
        :title="$t('security.resetlegalpwd')"
        :value="$t('common.modify')"
        is-link
        to="/resetLegalPwd"
      />
    </van-cell-group>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "SecurityView",
  components: { Header },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
};
</script>

<style>
</style>
